import React from 'react';
import { Link } from 'react-router-dom';
import './ProductCard.css';

function ProductCard({ product }) {
  return (
    <div className="catalog-card">
      <div className="catalog-image">
        <img
          src={product.image}
          alt={product.name}
          className="product-card-image"
        />
      </div>
      <div className="catalog-info">
        <span className="product-category">{product.category}</span>
        <h3>{product.name}</h3>
        <p className="product-desc">{product.description}</p>
        <p className="product-specs"><strong>Specs:</strong> {product.specs}</p>
        <Link
          to={`/contact?product=${encodeURIComponent(product.name)}`}
          className="btn btn-outline product-btn"
        >
          Inquire Now
        </Link>
      </div>
    </div>
  );
}

export default ProductCard;
